@if (content.title) {
  <div>
    <h3 class="skymiles-benefits-section-header">
      <span>{{ content.title }}</span>
    </h3>

    @if (displayManagerService.index$ | ngrxPush; as index) {
      <div
        [className]="
          'skymiles-benefits-section skymiles-benefits-section__last-tier--' +
          (+index === 4 || content.stacks.length === 1)
        "
      >
        <div
          [className]="
            'skymiles-benefits-section__container skymiles-benefits-section__container--' +
            content.stacks[+index].tier
          "
        >
          <div class="skymiles-benefits-section__container__details" #swipeZone>
            <div class="skymiles-benefits-section__container__details__member">
              <span
                class="skymiles-benefits-section__container__details__member__title"
                [innerHtml]="content.stacks[+index].title"
              ></span>
            </div>
            <idp-goodies
              [content]="content"
              [index]="+index"
              (clickAnalyticsEvent)="clickAnalyticsEvent.emit($event)"
            ></idp-goodies>
          </div>
          @if (content.stacks.length !== 1) {
            <div class="skymiles-benefits-section__container__seperator"></div>
            <idp-paginator
              [paginator]="{
                index: +index,
                actions: content.actions,
                ariaLabels: { title: getAriaLabels(content.stacks) },
                count: content.stacks.length
              }"
            ></idp-paginator>
          }
        </div>
        @if (+index !== 4 && content.stacks.length !== 1) {
          <idp-peak-bar
            class="skymiles-benefits-section__peak-bar"
            [content]="content"
            [index]="+index"
          ></idp-peak-bar>
        }
      </div>
    }
  </div>
}
